import loadable from '@loadable/component';

export const GolfmSiteWrapper = loadable(
  () => import(/* webpackChunkName: "golfm-site" */ './GolfmSiteWrapper'),
);
